import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import UserService from "../../../services/UserService";
import { ROUTES } from "../../../config/routes";

import FarelanesLogo from "../../../assets/v3/title-my.farelanes.svg";
import FarelanesCOPILOTLogo from "../../../assets/v3/title-my.farelanes-copilot.svg";
import FarelanesSilverLogo from "../../../assets/v3/title-my.farelanes-silver.svg";
import FarelanesGoldLogo from "../../../assets/v3/title-my.farelanes-gold.svg";
import FarelanesPlatinumLogo from "../../../assets/v3/title-my.farelanes-platinum.svg";

export const NavBarBrand = () => {
    const [plan, setPlan] = useState("Default");
    const [loading, setLoading] = useState(true);

    const { isAuthenticated, getAccessTokenSilently, loginWithRedirect } = useAuth0();

    useEffect(() => {
        let alive = true;

        async function fetchPlan() {
            try {
                if (!isAuthenticated) {
                    // Not logged in: show default brand and stop.
                    if (alive) setLoading(false);
                    return;
                }
                const token = await getAccessTokenSilently();
                const resp = await UserService.mySubscription(token);
                if (!alive) return;

                // Normalize defensively
                const v = (resp?.data || "").toString();
                setPlan(v || "Default");
            } catch (err) {
                console.warn("Subscription lookup failed:", err);
                // Optionally bounce to login if token/session expired
                try {
                    await loginWithRedirect({ appState: { returnTo: "/" } });
                } catch (e) {
                    // If redirect fails, at least render default brand
                    if (alive) setPlan("Default");
                }
            } finally {
                if (alive) setLoading(false);
            }
        }

        fetchPlan();
        return () => {
            alive = false;
        };
    }, [isAuthenticated, getAccessTokenSilently, loginWithRedirect]);

    const LOGOS = {
        CoPilot: { src: FarelanesCOPILOTLogo, alt: "Farelanes CoPilot" },
        Silver: { src: FarelanesSilverLogo, alt: "Farelanes Silver" },
        Gold: { src: FarelanesGoldLogo, alt: "Farelanes Gold" },
        Platinum: { src: FarelanesPlatinumLogo, alt: "Farelanes Platinum" },
        Default: { src: FarelanesLogo, alt: "Farelanes" },
    };

    // Fallbacks while loading / unknown plan here
    const { src, alt } = LOGOS[plan] || LOGOS.Default;

    return (
        <div>
            <NavLink to={ROUTES.DASHBOARD} aria-label="Go to dashboard">
                <img
                    src={src}
                    alt={alt}
                    width={210}
                    height={59}
                    style={{ display: "block", marginLeft: "20px" }}
                />
            </NavLink>
        </div>
    );
};
